<template>
<div id="app">

     <div class="container" >


          <div class="box">

            <div class="rightContent">
                <div class="main">

                    <div class="titles" style="font-size: 24px;margin: 0px 0 30px;">用户协议</div>


                    <div class="content" v-loading="loading" element-loading-text="拼命加载中">

                    </div>
                </div>

            </div>

          </div>
     </div>

</div>
</template>

<script>
  export default {
    data() {
      return {
        article:{},
        recommendList:[],
        list:[],
        dialogVisabled:false,
        loading:true,
        leftNavFixed:false,
        defaultOpeneds:["1","2"],
        title: '智慧人力零工系统-用户协议'
      }
    },

    mounted() {
      window.document.title = this.title
      scrollTo(0,0);
       window.addEventListener("scroll", this.handleScroll,true);
       this.type = 1;

       $('#app').css('width',window.outerWidth)
       $('.container').css('width',window.outerWidth)
       //文章数据
      this.articleData()
    },

    destroyed() {
       window.removeEventListener('scroll', this.handleScroll, true)
    },

    methods: {
      handleScroll(){
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        // console.log("协议",scrollTop)
        // console.log( "文章高度", $('.rightContent').height() )
         let rightContent =  $('.rightContent').height()
         if((rightContent-200) > scrollTop) {
           if(scrollTop>140){
             //this.dialogVisabled = true
             this.leftNavFixed = true;
           }else{
             //this.dialogVisabled = false
             this.leftNavFixed = false;
           }
         }else{
           this.leftNavFixed = false;
         }

      },

      articleData(){
        this.gets('common/noticeInfo',{'type':this.type}).then(res=>{
          this.loading = false
          $('.content').html(res.data.data.value)
          $('.content img').css('width','100%')
          $('.content h1').css('font-size','18px');
          $('.content h2').css('font-size','15px');
          $('.content .ql-align-center').css('text-align','center');
          $('.content .ql-align-right').css('text-align','right');

        })
      },
      otherArticle(val){
        scrollTo(0,0);
        this.id = val
        this.articleData()
      },
      handleOpen() {

      },
      handleClose() {

      },


    }
  }
</script>

<style scoped>
  #app{
     overflow:auto;
  }
  .container{
    width: 100%;background: #f5f5f5;
   font-family:  Helvetica,"Avenir", Arial, sans-serif;

  }
  .container .box{
    display: flex;justify-content: space-between;margin: auto;
    position: relative;
  }
  .leftNavFixed{
    position: fixed;
    z-index: 9;
    top: 0;
  }


  .leftNav .navmenu{width: 220px;background: #fff;border-radius: 6px;padding:30px 20px;box-sizing: border-box;
  text-align: left;
  }
  .container .rightContent{
    position: relative;
    right: 0;
  }
  .container .box .main{width: 100%;
  text-align: start;background: #fff;padding: 30px;box-sizing: border-box;}
  .main .title{font-size: 32px;font-weight: normal;color: #40494E;margin: 30px 0 20px;}
  .main .info{display: flex;height: 25px;align-items: center;line-height: 25px;font-size: 14px;color: #C1C1C1;position: relative;margin-bottom: 30px;}
  .main .info>div{margin-right:35px ;}
  .main .info .tags{position: absolute;right: 0;}
  .main .content{
    margin-top: 15px;
    font-size: 14px;
  }
  .main .content .ql-align-center{
	  text-align: center;
  }
  .main .content .ql-align-right{
  	  text-align: right;
  }
    .main .content h1{
      font-size: 18px;
    }


  .articleInfo .articleMain{color: #849198;}


</style>



// WEBPACK FOOTER //
// src/view/ourPolicy/magreement.vue